import { Dispatch, SetStateAction } from 'react';
import { useMediaQuery } from '@mui/material';
import { TabsNav, SelectNav, IOperationAllow, disableOperationsHelpDesk } from '../common';
import { labels } from '.';

export const TeamNav = ({
  currentTab,
  operations,
  setCurrentTab,
}: {
  currentTab: number;
  operations: IOperationAllow[];
  setCurrentTab: Dispatch<SetStateAction<number>>;
}) => {
  const matchesTabsBreakpoint = useMediaQuery('(min-width:40em)', {
    noSsr: true,
  });

  return matchesTabsBreakpoint ? (
    <TabsNav
      currentTab={currentTab}
      labels={labels(operations, disableOperationsHelpDesk(operations))}
      onChange={setCurrentTab}
      ariaLabel="ra tabs"
    />
  ) : (
    <SelectNav
      currentTab={currentTab}
      labels={labels(operations, disableOperationsHelpDesk(operations))}
      onChange={setCurrentTab}
      ariaLabel="ra tabs"
    />
  );
};
